// import React, { useEffect, useState } from "react";
// import { Modal, Input, Button, Form } from "antd";
// import { GetPersonaFinep, PostPersonaFinep, PutPersonaFinep } from "../../../API/PersonaFinepAPI";
// import Loader from "../../Shared/Loader";
// import { PersonaFinepModel } from "../../../Models/PersonaFinepModel";
// import { useAuth } from "../../../Hooks/useAuth";
// import { useParams } from "react-router-dom";
// interface PersonaFinepModalProps {
//     show: boolean;
//     handleClose: () => void;
//     getPersons: () => Promise<void>;
//     id?: string;
// }
// export const PersonaFinepModal = ({ show, handleClose, id, getPersons }: PersonaFinepModalProps) => {
//     const [cpf, setCPF] = useState('');
//     const [fullname, setFullName] = useState('');
//     const [email, setEmail] = useState('');
//     const [loading, setLoading] = useState(false);
//     const { registerId } = useParams();
//     const user = useAuth();

//     async function getPersona() {
//         setLoading(true);
//         const result = await GetPersonaFinep(id ?? '');
//         setCPF(result.cpf);
//         setFullName(result?.fullname ?? "");
//         setEmail(result.email ?? "");
//         setLoading(false);
//     }

//     async function handleSendNaturalPerson() {
//         setLoading(true);

//         const person: PersonaFinepModel = {
//             id: id ?? "",
//             cpf: cpf,
//             fullname: fullname,
//             email: email,
//             userEmail: user.userEmail,
//             registerId: registerId
//         };

//         if (id) {
//             await PutPersonaFinep(person).catch(() => setLoading(false));
//         } else {
//             await PostPersonaFinep(person).catch(() => setLoading(false));
//         }

//         setLoading(false);
//         getPersons();
//         handleClose();
//     }

//     useEffect(() => {
//         if (id && show) {
//             getPersona();
//         }
//     }, [show]);

//     return (
//         <>
//             {loading && <Loader />}
//             <Modal
//                 open={show}
//                 onCancel={handleClose}
//                 footer={null}
//                 centered
//                 width={450}
//             >
//                 <h6 style={{ marginBottom: 24 }}><strong>Novo Agrupamento</strong></h6>
//                 <Form layout="vertical" onFinish={handleSendNaturalPerson}>
//                     <Form.Item label="CPF:">
//                         <Input 
//                             placeholder="000.000.000-00" 
//                             value={cpf}  
//                             onChange={(e) => setCPF(e.target.value)}
//                         />
//                     </Form.Item>
//                     <Form.Item label="Nome Completo:">
//                         <Input 
//                             placeholder="Fulano de Tal" 
//                             value={fullname}
//                             onChange={(e) => setFullName(e.target.value)}
//                         />
//                     </Form.Item>
//                     <Form.Item label="Email:">
//                         <Input 
//                             placeholder="fulanodetal@email.com" 
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                         />
//                     </Form.Item>
//                     <div style={{ display: "flex", width: "100%", gap: "8px", marginTop: "16px" }}>
//                         <Button onClick={handleClose} style={{ background: "#F3F3F3", flex: 1 }}>
//                             Cancelar
//                         </Button>
//                         <Button type="primary" htmlType="submit" style={{ background: "#0000A4", flex: 1 }}>
//                             Confirmar
//                         </Button>
//                     </div>
//                 </Form>
//             </Modal>
//         </>
//     );
// };







import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Form } from "antd";
import { GetPersonaFinep, PostPersonaFinep, PutPersonaFinep } from "../../../API/PersonaFinepAPI";
import Loader from "../../Shared/Loader";
import { PersonaFinepModel } from "../../../Models/PersonaFinepModel";
import { useAuth } from "../../../Hooks/useAuth";
import { useParams } from "react-router-dom";
interface PersonaFinepModalProps {
    show: boolean;
    handleClose: () => void;
    getPersons: () => Promise<void>;
    id?: string;
}

function isValidCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]+/g, '');

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    if (/^(\d)\1+$/.test(cpf)) return false;
    
    const sequenciaisInvalidos = [
        '12345678909',
        '01234567890',
        '98765432100'
    ];
    if (sequenciaisInvalidos.includes(cpf)) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
    let firstDigit = (sum * 10) % 11;
    if (firstDigit === 10 || firstDigit === 11) firstDigit = 0;
    if (firstDigit !== parseInt(cpf.charAt(9))) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
    let secondDigit = (sum * 10) % 11;
    if (secondDigit === 10 || secondDigit === 11) secondDigit = 0;
    if (secondDigit !== parseInt(cpf.charAt(10))) return false;

    return true;
}

function formatCPF(value: string): string {
    const cpf = value.replace(/\D/g, '').slice(0, 11);
    return cpf
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export const PersonaFinepModal = ({ show, handleClose, id, getPersons }: PersonaFinepModalProps) => {
    const [loading, setLoading] = useState(false);
    const { registerId } = useParams();
    const user = useAuth();
    const [form] = Form.useForm();
    async function getPersona() {
        setLoading(true);
        const result = await GetPersonaFinep(id ?? '');
        form.setFieldsValue({
            cpf: result.cpf,
            fullname: result.fullname ?? '',
            email: result.email ?? '',
        });
        setLoading(false);
    }

    async function handleSendNaturalPerson(values: any) {
        setLoading(true);
        const person: PersonaFinepModel = {
            id: id ?? "",
            cpf: values.cpf,
            fullname: values.fullname,
            email: values.email,
            userEmail: user.userEmail,
            registerId: registerId
        };
        if (id) {
            await PutPersonaFinep(person).catch(() => setLoading(false));
        } else {
            await PostPersonaFinep(person).catch(() => setLoading(false));
        }
        setLoading(false);
        getPersons();
        handleClose();
        form.resetFields();
    }

    useEffect(() => {
        if (id && show) {
            getPersona();
        } else {
            form.resetFields();
        }
    }, [show]);

    return (
        <>
            {loading && <Loader />}
            <Modal
                open={show}
                onCancel={handleClose}
                footer={null}
                centered
                width={450}
                closeIcon
            >
                <h6 style={{ marginBottom: 24 }}>
                    <strong>Novo Agrupamento</strong>
                </h6>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSendNaturalPerson}
                >
                    <Form.Item
                        label="CPF"
                        name="cpf"
                        rules={[
                            { required: false, message: 'CPF é obrigatório' },
                            {
                                validator: (_, value) =>
                                    !value || isValidCPF(value)
                                        ? Promise.resolve()
                                        : Promise.reject('CPF inválido'),
                            },
                        ]}
                    >
                        <Input
                            placeholder="000.000.000-00"
                            onChange={(e) => {
                                const formatted = formatCPF(e.target.value);
                                form.setFieldsValue({ cpf: formatted });
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Nome Completo"
                        name="fullname"
                        rules={[{ required: false, message: 'Nome é obrigatório' }]}
                    >
                        <Input placeholder="Fulano de Tal" />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: false, message: 'Email é obrigatório' },
                            { type: 'email', message: 'Email inválido' },
                        ]}
                    >
                        <Input placeholder="fulanodetal@email.com" />
                    </Form.Item>
                    <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
                        <Button
                            onClick={handleClose}
                            style={{ flex: 1, background: "#F3F3F3" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ flex: 1, background: "#00008B", color: "#fff" }}
                        >
                            Confirmar
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
};